import { Talent } from '../../Classes'

const tier7 = [
  null,
  new Talent(
    'Shield Slam',
    'inv_shield_05',
    ['Slam the target with your shield, dealing 225 to 235 damage, modified by your block value and has a 50% chance of dispelling 1 magic effect on the target. Generates a hight amount of threat.'],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    '20 Rage',
    'Melee Range',
    'Instant cast',
    '6 sec cooldown'
  ),
  null,
  null,
]

export default tier7
